import React from 'react';
import { Button } from '@mui/material';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';

const sizes = [48, 72, 96, 144, 192, 512];

const DownloadButton = ({ image }) => {
    const downloadAll = async () => {
        const zip = new JSZip();
        const iconsFolder = zip.folder('icons');

        // Generate icons
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        const img = new Image();
        img.src = URL.createObjectURL(image);

        await new Promise((resolve) => {
            img.onload = () => {
                sizes.forEach((size) => {
                    canvas.width = size;
                    canvas.height = size;
                    context.drawImage(img, 0, 0, size, size);
                    const dataUrl = canvas.toDataURL();
                    const base64Data = dataUrl.split(',')[1];
                    iconsFolder.file(`icon-${size}x${size}.png`, base64Data, { base64: true });
                });
                resolve();
            };
        });

        // Generate manifest.json
        const manifest = {
            name: "PWA Icon Generator",
            short_name: "IconGen",
            icons: sizes.map((size) => ({
                src: `icons/icon-${size}x${size}.png`,
                sizes: `${size}x${size}`,
                type: "image/png",
            })),
            start_url: ".",
            display: "standalone",
            background_color: "#ffffff",
            theme_color: "#000000",
        };

        const manifestBlob = new Blob([JSON.stringify(manifest, null, 2)], { type: 'application/json' });
        zip.file('manifest.json', manifestBlob);

        // Generate and download zip file
        const content = await zip.generateAsync({ type: 'blob' });
        saveAs(content, 'pwa-assets.zip');
    };

    return (
        <Button variant="contained" color="primary" onClick={downloadAll} disabled={!image}>
            Download All
        </Button>
    );
};

export default DownloadButton;
